export const AUDITORY_MODEL = {
  paso: 6,
  pasoDescripcion: 'PASO_GRACIAS',
};
